export default __webpack_public_path__ + "static/media/ans5.9b33d959.png";